import React from 'react'
import { Grid } from "@mui/material"

import { AnalyzerEvolutionModal, AnalyzerPricesChart, AnalyzersTable, AnalyzerTableState } from "Pages/AnalyzersV2/@components"
import { UpdatingVeil } from "Pages/AnalyzersV2/@components/CarPick/TableState"
import { analyzerCarPick, isAnalyzerLoading, responseData } from "Pages/AnalyzersV2/@signals"
import useAnalyzerData from "Pages/AnalyzersV2/@hooks/useData"
import { useAnalyzerDorFilters } from "Pages/AnalyzersV2/Dor/@hooks"
import { pickOn } from "Pages/AnalyzersV2/@services/carPick"
import { NoDataFound, AppResultsSkeleton } from "@components"


export default function DorContent() {
	const {
		tableData,
		tableColumns,
		dataEmpty,
		evolutionData,
		chartContent,
		noResults
	} = useAnalyzerData(responseData.value)
	const { onSubmit } = useAnalyzerDorFilters()

	// the Cars selector (CU-869fmpqfm): a car picked asks again without Search, the table stays under "Updating…"
	const onPick = pick => {
		analyzerCarPick.value = pick
		onSubmit(false, { keep: true })
	}

	// no prices with a car picked: the card stays, with the field and why (decision 2, UX Obs. 1)
	if (noResults && !pickOn(analyzerCarPick.value)) {
		return <NoDataFound/>
	}

	if (dataEmpty && !isAnalyzerLoading.value) return null

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			{isAnalyzerLoading.value && <AppResultsSkeleton rows={7} columns={8}/>}
			{!isAnalyzerLoading.value &&
				<AnalyzerTableState noResults={noResults} onPick={onPick}>
					<AnalyzersTable
						tableData={tableData}
						columns={tableColumns}
						evolutionData={evolutionData}
						carPick={{ onPick }}
					/>
				</AnalyzerTableState>}
		</Grid>
		{!noResults && <Grid item xs={12}>
			<UpdatingVeil><AnalyzerPricesChart {...chartContent} isDateAxis/></UpdatingVeil>
		</Grid>}
		<Grid item xs={12}>
			<AnalyzerEvolutionModal/>
		</Grid>
	</Grid>

}
